import React, { useState, useCallback, useRef } from "react";
import { ReferenceArea } from "recharts";

export default function useChartZoom() {
  const [refAreaLeft, setRefAreaLeft] = useState(null);
  const [refAreaRight, setRefAreaRight] = useState(null);
  const [domainLeft, setDomainLeft] = useState(null);
  const [domainRight, setDomainRight] = useState(null);

  const leftRef = useRef(null);
  const rightRef = useRef(null);

  const onMouseDown = useCallback((e) => {
    if (e?.activeLabel != null) {
      leftRef.current = e.activeLabel;
      rightRef.current = null;
      setRefAreaLeft(e.activeLabel);
      setRefAreaRight(null);
    }
  }, []);

  const onMouseMove = useCallback((e) => {
    if (leftRef.current != null && e?.activeLabel != null) {
      rightRef.current = e.activeLabel;
      setRefAreaRight(e.activeLabel);
    }
  }, []);

  const onMouseUp = useCallback(() => {
    const left = leftRef.current;
    const right = rightRef.current;
    leftRef.current = null;
    rightRef.current = null;
    setRefAreaLeft(null);
    setRefAreaRight(null);

    if (left == null || right == null || left === right) return;

    const [lo, hi] = left < right ? [left, right] : [right, left];
    setDomainLeft(lo);
    setDomainRight(hi);
  }, []);

  const reset = useCallback(() => {
    setDomainLeft(null);
    setDomainRight(null);
  }, []);

  const isZoomed = domainLeft != null;
  const isDragging = refAreaLeft != null;

  const selectionArea =
    isDragging && refAreaRight != null
      ? React.createElement(ReferenceArea, {
          x1: refAreaLeft,
          x2: refAreaRight,
          strokeOpacity: 0.3,
          fill: "#8884d8",
          fillOpacity: 0.15,
        })
      : null;

  return {
    domain: isZoomed ? [domainLeft, domainRight] : undefined,
    isZoomed,
    selectionArea,
    onMouseDown,
    onMouseMove,
    onMouseUp,
    reset,
  };
}
